/**
 * The phone app's words for the CRM's reads (piece 35, *Reads and groundwork
 * (batch CR1)*; decision 4410): a stage card's row read on the phone and the
 * Deal's value line, kept beside the second release's and spread into the one
 * string lookup. A word the web already says, such as a card's Notes, its Due or
 * the Now beside the current stage, is read from the web's own key and is not
 * repeated here.
 */
export const CRM_READS_STRINGS = {
  'mobile.crm.stage.done': 'Done',
  'mobile.crm.stage.open': 'Open',
  'mobile.crm.stage.notApplicable': 'N/A',
  'mobile.crm.deal.value': 'Value',
  // T2455: a row naming a record the phone has no screen for, such as an RFQ, says so beneath itself.
  'mobile.crm.notOpened': 'The phone does not open this yet. Open it on the web.',
} as const;
